import React from "react";
import { Link } from "react-router-dom";
import Reveal from "./reveal";

/** Case study tile. `c` is an entry from data.js `cases`. */
export default function CaseCard({ c, delay = 0 }) {
  return (
    <Reveal delay={delay}>
      <Link to={`/work/${c.slug}`} className={`case ${c.cls}`}>
        <small>{c.tag}</small>
        <h3>{c.title}</h3>
        <p>{c.desc}</p>
        <div className="results">
          <div><b>{c.a}</b><span>{c.al}</span></div>
          <div><b>{c.b}</b><span>{c.bl}</span></div>
        </div>
        <span className="case-link">View Case Study</span>
      </Link>
    </Reveal>
  );
}
